import { FeaturesDesktop, FeaturesMobile } from '../secondary-features-tabs.tsx'
import { Container } from '../ui/container.tsx'

export default function SecondaryFeatures() {
	return (
		<section
			id="secondary-features"
			aria-label="Features for simplifying everyday business tasks"
			className="pb-14 pt-20 sm:pb-20 sm:pt-32 lg:pb-32"
		>
			<Container>
				<div className="mx-auto max-w-2xl md:text-center">
					<h2 className="font-display text-3xl tracking-tight text-slate-900 dark:text-white sm:text-4xl">
						Simplify everyday event tasks.
					</h2>
					<p className="mt-4 text-lg tracking-tight text-slate-700 dark:text-white">
						Because you’d probably be a little confused if we suggested you
						complicate your everyday event tasks instead.
					</p>
				</div>
				<FeaturesMobile />
				<FeaturesDesktop />
			</Container>
		</section>
	)
}
